// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.godMWv {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2);
}

.SKrhcn {
  font-size: var(--type-label-lg-font-size);
  font-weight: var(--type-label-lg-font-weight);
  color: var(--text-neutral-dark);
  margin: 0;
}

.aziqaV {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-3);
}

._HUuwS {
  flex: 1;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-2);
  background-color: var(--surface-neutral-pale);
  border-radius: var(--radius-s);
  cursor: pointer;
  transition: all 0.2s ease;
  gap: var(--spacing-1-5);
}

._HUuwS[data-selected='true'] {
  background-color: var(--surface-primary-subtle);
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/ReleaseTypeSection/ReleaseTypeSection.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,6CAA6C;EAC7C,8BAA8B;EAC9B,eAAe;EACf,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;AACjD","sourcesContent":[".formSection {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-2);\n}\n\n.label {\n  font-size: var(--type-label-lg-font-size);\n  font-weight: var(--type-label-lg-font-weight);\n  color: var(--text-neutral-dark);\n  margin: 0;\n}\n\n.horizontalRadioGroup {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-3);\n}\n\n.horizontalRadioItem {\n  flex: 1;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-2);\n  background-color: var(--surface-neutral-pale);\n  border-radius: var(--radius-s);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  gap: var(--spacing-1-5);\n}\n\n.horizontalRadioItem[data-selected='true'] {\n  background-color: var(--surface-primary-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formSection": `godMWv`,
	"label": `SKrhcn`,
	"horizontalRadioGroup": `aziqaV`,
	"horizontalRadioItem": `_HUuwS`
};
module.exports = ___CSS_LOADER_EXPORT___;
